const SwingIcon = ({ size = 20, color = '#7BB9F5' }) => (
  <svg
    width={size}
    height={(size * 13) / 19}
    viewBox="0 0 19 13"
    fill="none"
  >
    <path
      d="M14.2532 9.38334L18.1793 9.39745C18.7485 9.3995 18.9278 10.2596 18.1091 10.353L0.625414 10.2902C-0.312114 10.1995 -0.0160788 9.33206 0.427148 9.33366L4.42132 9.34801C4.13738 7.56507 4.6385 5.75669 6.00852 4.54755C8.4766 2.36981 12.359 3.10706 13.813 6.05046C14.341 7.11869 14.3872 8.21472 14.2532 9.38334Z"
      fill={color}
    />
    <path
      d="M3.50798 11.1318L14.9651 11.1562C15.6213 11.2357 15.6251 11.9808 15.1007 12.047L3.55495 12.0056C3.08491 11.9576 3.04768 11.2342 3.50799 11.1305L3.50798 11.1318Z"
      fill={color}
    />
    <path
      d="M9.33936 0.0334373C9.07768 0.0324969 8.86583 0.242822 8.86489 0.503218L8.85971 1.94466C8.85878 2.20506 9.06911 2.41692 9.32951 2.41785C9.59119 2.41879 9.80304 2.20845 9.80398 1.94806L9.80916 0.506612C9.81009 0.246215 9.59976 0.0343731 9.33936 0.0334373Z"
      fill={color}
    />
    <path
      d="M16.4926 4.15638C16.3626 3.92929 16.0745 3.85098 15.8485 3.98037L14.5976 4.69661C14.3716 4.826 14.2933 5.11408 14.4227 5.34005C14.5527 5.56715 14.8408 5.64545 15.0668 5.51607L16.3177 4.79982C16.5437 4.67043 16.622 4.38236 16.4926 4.15638Z"
      fill={color}
    />
    <path
      d="M17.5885 8.27111C17.5895 8.00943 17.3791 7.79758 17.1187 7.79665L15.6773 7.79147C15.4169 7.79053 15.205 8.00087 15.2041 8.26126C15.2032 8.52294 15.4135 8.7348 15.6739 8.73573L17.1153 8.74092C17.3757 8.74185 17.5876 8.53151 17.5885 8.27111Z"
      fill={color}
    />
    <path
      d="M13.4976 1.15558C13.2714 1.02393 12.9828 1.10015 12.8518 1.32519L12.1266 2.57093C11.9956 2.79597 12.0718 3.08461 12.2968 3.21562C12.523 3.34728 12.8116 3.27104 12.9426 3.046L13.6679 1.80026C13.7989 1.57522 13.7226 1.28659 13.4976 1.15558Z"
      fill={color}
    />
    <path
      d="M2.20039 4.10289C2.06874 4.32904 2.14496 4.61767 2.37 4.74868L3.61575 5.4739C3.84079 5.60491 4.12942 5.52868 4.26043 5.30363C4.39209 5.07748 4.31587 4.78885 4.09082 4.65784L2.84507 3.93262C2.62003 3.80161 2.3314 3.87785 2.20039 4.10289Z"
      fill={color}
    />
    <path
      d="M1.08118 8.2118C1.08023 8.47348 1.29056 8.68533 1.55096 8.68626L2.9924 8.69144C3.2528 8.69238 3.46466 8.48204 3.46559 8.22165C3.46653 7.95997 3.25619 7.74811 2.9958 7.74718L1.55435 7.742C1.29395 7.74106 1.08211 7.9514 1.08118 8.2118Z"
      fill={color}
    />
    <path
      d="M5.23756 1.12348C5.01047 1.25351 4.93216 1.54158 5.06155 1.76756L5.7778 3.01849C5.90718 3.24447 6.19526 3.32276 6.42124 3.19338C6.64833 3.06335 6.72664 2.77528 6.59725 2.5493L5.881 1.29837C5.75162 1.07239 5.46354 0.994095 5.23756 1.12348Z"
      fill={color}
    />
  </svg>
);

export { SwingIcon };